import { receiptConstants, apiConstants } from '../constants';
import url from '../../helpers/url';

export const saveReceipt = (form) => ({
    type: apiConstants.API,
    payload: {
        url: form.id ?
            url.recipientProgressReceipt.replace(':recipientId', form.recipientId).replace(':progressId', form.progressId).replace(':receiptId', form.id) :
            url.recipientProgressReceipts.replace(':recipientId', form.recipientId).replace(':progressId', form.progressId),
        method: 'POST',
        body: form,
        request: () => ({ type: receiptConstants.SAVING_RECEIPT_REQUEST }),
        success: (data) => ({ type: receiptConstants.SAVING_RECEIPT_SUCCESS, data }),
        failure: (error) => ({ type: receiptConstants.SAVING_RECEIPT_FAILURE, error }),
        formatData: (data) => ({ form: { ...data[0] }}),
        progress: {
            success: { message: () => 'Saved Receipt.' }
        }
    }
});

export const deleteReceipt = ({ recipientId, progressId, receiptId }) => ({
    type: apiConstants.API,
    payload: {
        url: url.recipientProgressReceipt.replace(':recipientId', recipientId).replace(':progressId', progressId).replace(':receiptId', receiptId),
        method: 'DELETE',
        request: () => ({ type: receiptConstants.DELETE_RECEIPT_REQUEST }),
        success: (data) => ({ type: receiptConstants.DELETE_RECEIPT_SUCCESS, data }),
        failure: (error) => ({ type: receiptConstants.DELETE_RECEIPT_FAILURE, error }),
        formatData: () => (progressId),
        progress: {
            request: { message: () => 'Deleting receipt' },
            success: { message: () => 'Deleted receipt.' }
        }
    }
});

export const loadReceipts = ({ recipientId, progressId }) => ({
    type: apiConstants.API,
    payload: {
        url: url.recipientProgressReceipts.replace(':recipientId', recipientId).replace(':progressId', progressId),
        request: () => ({ type: receiptConstants.LOAD_RECEIPTS_REQUEST }),
        success: (data) => ({ type: receiptConstants.LOAD_RECEIPTS_SUCCESS, data }),
        failure: (error) => ({ type: receiptConstants.LOAD_RECEIPTS_FAILURE, error })
    }
});



// WEBPACK FOOTER //
// ./src/redux/actions/receipt.actions.js